var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcFolder32X32 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 23,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic_folder_32x32_svg__a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "ic_folder_32x32_svg__b",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 28,
  height: 22
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M28 0H0v22h28V0Z",
  fill: "#fff"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#ic_folder_32x32_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28 8.01v-4c0-.55-.45-1-1-1H11.83c-.53 0-1.04-.21-1.41-.59L8.59.59C8.21.21 7.71 0 7.18 0H1C.45 0 0 .46 0 1.01v7h28Z",
  fill: "#7DBEFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 8.01v12c0 1.1.9 2 2 2h24c1.1 0 2-.9 2-2v-12H0Z",
  fill: "#2D91FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 6.01h22c.55 0 1 .45 1 1v1H2v-1c0-.55.45-1 1-1Z",
  fill: "#fff"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic_folder_32x32_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h28v22.01H0z"
})))));
export default SvgIcFolder32X32;